import { Alert, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { PlatformPage } from "@/components/PlatformPage";
import { useFeePolicyDrafts } from "../hooks/useFeePolicies";

export function FeePolicyDraftIndexPage() {
  const query = useFeePolicyDrafts();
  return (
    <PlatformPage
      title="Fee drafts"
      isLoading={query.isLoading}
      actions={
        <Button
          component={Link}
          to="/contracts/fee-policies/new"
          size="small"
          variant="contained"
        >
          New fee draft
        </Button>
      }
    >
      <Stack spacing={2}>
        <Alert severity="info">
          Review publication to see the current source requirements for a saved draft.
        </Alert>
        {query.isError ? (
          <Alert severity="warning">
            Fee drafts unavailable.{" "}
            <Button size="small" onClick={() => void query.refetch()}>
              Retry
            </Button>
          </Alert>
        ) : query.data ? (
          <>
            <Typography variant="body2">
              {query.data.total} draft{query.data.total === 1 ? "" : "s"}{" "}
              returned by the source.
            </Typography>
            {query.data.items.map((draft) => (
              <Stack key={draft.draft_id} spacing={0.5}>
                <Typography variant="subtitle2">
                  Effective {new Date(draft.effective_from).toLocaleString()} —
                  revision {draft.revision}
                </Typography>
                <Button
                  component={Link}
                  to={`/contracts/fee-policies/${draft.draft_id}`}
                  size="small"
                  variant="outlined"
                >
                  Edit fee draft
                </Button>
                <Button component={Link} to={`/contracts/fee-policies/${draft.draft_id}/publication`} size="small">
                  Review publication
                </Button>
              </Stack>
            ))}
          </>
        ) : null}
      </Stack>
    </PlatformPage>
  );
}
